export default __webpack_public_path__ + "static/media/roboleft.c1abce3a.png";